export const PAGE_PRICING_SERVICE_IDS = [
  // Add a service code to use page pricing, for example "proofreading".
  "5"
];

export const MAX_PAGES = 500;

export const PAYMENT_ACCOUNT = {
  bankName: 'مصرف الإنماء',
  accountHolder: 'نهى ناصر الحازمي',
  accountNumber: '68207060130000',
  iban: 'SA3105000068207060130000',
};

export const WHATSAPP_NUMBER = '966530494038';

function listedIds() {
  return PAGE_PRICING_SERVICE_IDS.map((id) => String(id));
}

export function isPagePricingService(serviceOrId) {
  if (serviceOrId === undefined || serviceOrId === null || serviceOrId === '') return false;

  const candidates = [];
  if (typeof serviceOrId === 'object') {
    if (serviceOrId.id !== undefined && serviceOrId.id !== null && serviceOrId.id !== '') {
      candidates.push(String(serviceOrId.id));
    }
    if (
      serviceOrId.numericId !== undefined &&
      serviceOrId.numericId !== null &&
      serviceOrId.numericId !== ''
    ) {
      candidates.push(String(serviceOrId.numericId));
    }
  } else {
    candidates.push(String(serviceOrId));
  }

  const enabled = listedIds();
  return candidates.some((id) => enabled.includes(id));
}

function positivePrice(value) {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : null;
}

export function pricePerPage(service) {
  const base = positivePrice(service?.price);
  if (base != null) return base;

  const morning = positivePrice(service?.morningPrice);
  const evening = positivePrice(service?.eveningPrice);
  if (morning != null && evening != null) {
    return morning === evening ? morning : null;
  }
  return morning ?? evening;
}

export function formatSar(amount) {
  return `${amount} ريال سعودي`;
}

export function parsePageCount(raw) {
  const text = String(raw ?? '').trim();
  if (!text) return { ok: false, error: 'أدخلي عدد الصفحات' };
  if (!/^\d+$/.test(text)) return { ok: false, error: 'أدخلي رقماً صحيحاً بدون فواصل أو حروف' };
  const value = Number(text);
  if (value < 1) return { ok: false, error: 'الحد الأدنى صفحة واحدة' };
  if (value > MAX_PAGES) return { ok: false, error: `الحد الأقصى ${MAX_PAGES} صفحة` };
  return { ok: true, value };
}

export function pagePricingTotal(service, pages) {
  const rate = pricePerPage(service);
  const count = parsePageCount(pages);
  if (rate == null || !count.ok) return null;
  return rate * count.value;
}

export function buildPagePricingWhatsAppUrl({ serviceName, pages, total }) {
  const text = `مرحبا، أود طلب ${serviceName} لعدد ${pages} صفحة. المجموع: ${total} ريال سعودي.`;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
}
